import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import Select from 'react-select'
import {DateRangePicker, Input } from 'rsuite';
import Header from "../Header";
import styles from "./style.module.css"
import { format } from "date-fns"
import axiosService from "../../utils/axios.service";
import "./scss/report.scss"
import { Table, Spin } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";
import { optionsCountBooking } from '../constant/GeneralData'
import _ from "lodash";

const CustomerCountPackageBooking = () => {
    const [title, setTitle] = useState("Báo cáo tổng quan Sale")
    const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [status, setStatus] = useState(0)
    const [keyword, setKeyword] = useState('')

    useEffect(() => {
        setTitle("Báo cáo tổng quan Sale")
    }, [])
    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }

    useLayoutEffect(() => {
        let isMounted = true;
        setLoading(true);

        const fetchData = async (sD, eD, s) => {
            const { data } = await async.parallel({
                data: (cb) => {
                    axiosService(`api/reports/customer/count/package-booking/${store}?start=${sD}&end=${eD}&store_id=${store}&keyword=${keyword}&status=${status}`, "GET").then(rs => {
                        const { data } = rs
                        cb(null, data)
                    })
                }
            })

            if (isMounted && data.code === 200) {
                const { dataChart, dataTable } = data.data
                setTable(dataTable)
                setLoading(false)
            }
        }

        fetchData(startDate, endDate, store);

        return () => {
            isMounted = false;
        }
    }, [startDate, endDate, store, keyword, status]);

    const columns = [
        {
            title: 'Khách hàng',
            dataIndex: 'customer_name',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
            sorter: (a, b) => a.name.length - b.name.length,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customer_mobile',
            align: "center",
            sorter: {
                compare: (a, b) => a.countBooking - b.countBooking,
                multiple: 3,
            },
        },
        {
            title: 'Thời gian đặt lịch',
            dataIndex: 'book_date',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Triệt',
            dataIndex: 'count_triet',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Da',
            dataIndex: 'count_da',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Khác',
            dataIndex: 'count_ot',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
    ];
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = _.debounce((e) => {
        if (e.length > 2 || e.length == 0) {
            setKeyword(e)
        }
    }, 1000)
    const onChangeDate = (e) => {
        if (e) {
            const eDate = format(e[1], 'yyyy-MM-dd')
            const sDate = format(e[0], 'yyyy-MM-dd')
            handleRangeDate(sDate, eDate)
        }
    }

    const changeStatusBooking = (e) => {
        setStatus(e.value)
    }
    return (
        <>
            <Header/>
            <div className={`${styles.background} container-fluid`}>
                <div className="search-report">
                    <Row>
                        <Col sm={3} xs={6} className="mb-2">
                            <Input data={keyword} placeholder="Tìm kiếm theo keyword" className="w-200" onChange={onChangeKeyword} />
                        </Col>
                        <Col sm={3} xs={6} className="mb-2" style={{position: "relative", zIndex: 99}}>
                            <Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} className="select" onChange={changeStatusBooking}  isSearchable={false} defaultValue={optionsCountBooking[0]} options={optionsCountBooking} />
                        </Col>
                        <Col sm={3} xs={12} className="mb-2">
                            <DateRangePicker
                                className="w-100"
                                placement={"bottomStart"}
                                format="yyyy-MM-dd"
                                onChange={onChangeDate}
                                showOneCalendar={true}
                                // ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                                defaultValue={[new Date(startDate), new Date(endDate)]}
                            />
                        </Col>

                    </Row>
                </div>
                
                <Spin spinning={loading} tip="Đang tải...">
                    <Row className="p-2">
                        <Col xs={12} className="p-2">
                            <div style={{ backgroundColor: "white" }} className="p-2">
                                <div className="border-bottom w-100 mb-2">
                                    Bảng số liệu chi tiết
                                </div>
                                <Table 
                                    columns={columns}
                                    dataSource={table}
                                    pagination={{ pageSize: 10 }} 
                                    scroll={{ x: 1300 }}
                                    bordered
                                    rowKey="customer_mobile"
                                />
                            </div>
                        </Col>
                    </Row>
                </Spin>
            </div>

        </>
    )
}
export default CustomerCountPackageBooking